// import createPersistedState from 'vuex-persistedstate'
import * as apiTag from '@/api/tag'
import * as apiNote from '@/api/note'
import * as apiBookmark from '@/api/bookmark'
import * as apiSearchCondition from '@/api/search-condition'
import * as _ from 'lodash'
import store from '@/store'

const getDefaultState = () => {
  const defaults = {
    lists: {
      note: [],
      bookmark: [],
      search: []
    },
    tags: [],
    complete: false,
    start: 0,
    per_page: 0,
    count: {
      note: null,
      bookmark: null,
      search: null
    },
    currentId: null,
    currentName: '',
    sharedList: [],
    sharedComplete: false,
    currentType: 'note', // note,bookmark,search
    currentTypeName: 'ノート', // ノート,ブックマーク,検索条件
    currentTypeNumber: 0, // 0,1,2
    typeNameList: [
      {
        type: 'note',
        typeName: 'ノート'
      },
      {
        type: 'bookmark',
        typeName: 'ブックマーク'
      },
      {
        type: 'search',
        typeName: '検索条件'
      }
    ]
  }

  return defaults
}

const tag = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists[state.currentType], list => list.id === state.currentId)
  },
  mutations: {
    setLists: (state, {lists, type}) => {
      state.lists[type].push(...lists)
    },
    setCount: (state, {num, type}) => {
      state.count[type] = num
    },
    subtractionCount: (state) => {
      state.count[state.currentType]--
    },
    resetComplete: (state) => {
      state.complete = false
    },
    setComplete: (state) => {
      state.complete = true
    },
    setId: (state, id) => {
      state.currentId = id
    },
    setName: (state, name) => {
      state.currentName = name
    },
    changeType: (state, type) => {
      state.currentType = type

      const index = _.findIndex(state.typeNameList, list => list.type === type)
      state.currentTypeName = state.typeNameList[index].typeName
      state.currentTypeNumber = index
    },
    resetSharedList: (state) => {
      state.sharedList.splice(0, state.sharedList.length)
    },
    setSharedList: (state, lists) => {
      state.sharedList.push(...lists)
    },
    resetSharedComplete: (state) => {
      state.sharedComplete = false
    },
    setSharedComplete: (state) => {
      state.sharedComplete = true
    },
    updateList: (state, { index, id, name, type }) => {
      const prev = state.lists[type][index]
      prev.name = name
      state.lists[type].splice(index, 1, prev)
    },
    deleteList: (state, {index, type}) => {
      state.lists[type].splice(index, 1)
    },
    resetList: (state) => {
      state.lists = { note: [], bookmark: [], search: [] }
    }
  },
  actions: {
    getLists: async ({ commit, state, dispatch }) => {
      commit('resetList')
      commit('resetComplete')

      const defaultParams = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'created', // created(日付順)
        ascending: 'desc'
        // type: 'note' // note(ノート)、bookmark(ブックマーク)、search(検索条件)
      }
      const typeParams = {
        note: {type: 'note'},
        bookmark: {type: 'bookmark'},
        search: {type: 'search'}
      }
      const params = {
        note: { ...defaultParams, ...typeParams.note},
        bookmark: { ...defaultParams, ...typeParams.bookmark},
        search: { ...defaultParams, ...typeParams.search}
      }

      for (const type in typeParams) {
        await apiTag
          .list(params[type])
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data
              // 初期表示時に全件取得
              await commit('setLists', {lists: lists, type: type})
              commit('setCount', {num: lists.length, type: type})
            } else {
              // status=その他: エラーダイアログを表示
              store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
            }
          })
      }
      commit('setComplete')
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id)
    },
    setEditName: async ({ commit }, name) => {
      await commit('setName', name)
    },
    changeType: async ({ commit }, type) => {
      await commit('changeType', type)
    },
    getSharedList: async ({ commit, state }) => {
      commit('resetSharedList')
      commit('resetSharedComplete')

      const params = {
        note: {
          start: 0,
          per_page: 0,
          search_order: 'date',
          ascending: 'desc',
          tags: [state.currentId]
        },
        bookmark: {
          start: 0,
          per_page: 0,
          search_order: 'created', // created(作成日順)
          ascending: 'desc',
          type: 1, // 1(ブックマーク)
          tags: [state.currentId],
          key: '' // qa(QA)、knowledge(ナレッジ)、両方取得なので空
        },
        search: {
          start: 0,
          per_page: 0,
          tags: [state.currentId]
        }
      }

      var api
      if (state.currentType === 'note') {
        api = apiNote
      } else if (state.currentType === 'bookmark') {
        api = apiBookmark
      } else if (state.currentType === 'search') {
        api = apiSearchCondition
      }
      await api
        .list(params[state.currentType])
        .then(async (response) => {
          const { data } = response
          if (data.status === 0) {
            const { lists } = data
            await commit('setSharedList', lists)
            commit('setSharedComplete', lists)
          }
        })
    },
    update: async ({ commit, state }, params) => {
      await apiTag
        .edit(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const save = _.clone(params)
            const index = _.findIndex(state.lists[state.currentType], list => list.id === params.id)
            save.index = index
            save.type = state.currentType
            commit('updateList', save)
          }
        })
        // TODO: APIできてから動作確認
    },
    delete: async ({ commit, state }, params) => {
      await apiTag
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists[state.currentType], list => list.id === params.id)
            commit('deleteList', {index: index, type: state.currentType})
            commit('subtractionCount')
          }
        })
    }
  }
}

export default tag
